import { render, staticRenderFns } from "./FormTurma.vue?vue&type=template&id=4221daf1"
import script from "./FormTurma.vue?vue&type=script&lang=js"
export * from "./FormTurma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports